module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-07.df7b26be.jpg";